import {
  ENTRY_TYPES,
  FAILED_STAGES,
  SESSION_STATUS,
  STEPS,
} from "./ai-curriculum.constants";

// Quick Start has no input step of its own — its entry card is the input.
const ENTRY_STEPS = {
  [ENTRY_TYPES.STATE_STANDARDS]: STEPS.STATE_SELECT,
  [ENTRY_TYPES.SYLLABUS_UPLOAD]: STEPS.SYLLABUS_UPLOAD,
  [ENTRY_TYPES.QUICK_START]: STEPS.FORM,
};

const STEPS_BY_STATUS = {
  [SESSION_STATUS.UPLOADING]: STEPS.ANALYZING,
  [SESSION_STATUS.ANALYZING]: STEPS.ANALYZING,
  [SESSION_STATUS.ANALYZED]: STEPS.FORM,
  [SESSION_STATUS.LOADING_STANDARDS]: STEPS.LOADING_STANDARDS,
  [SESSION_STATUS.STANDARDS_LOADED]: STEPS.FORM,
  [SESSION_STATUS.RECOMMENDING]: STEPS.RECOMMENDING,
  [SESSION_STATUS.RECOMMENDED]: STEPS.RECOMMENDATIONS,
};

export const RECOMMENDING_RETRY_HINT =
  "Your answers are saved — you can retry or adjust them first.";

export const EMPTY_STATE_SELECTION = {
  state: null,
  subject: null,
  sourceName: null,
};

// The state/subject/sourceName dropdowns carry {id, name} options whose id is
// the name itself, so the stored context reconstructs them directly.
export const stateSelectionFromContext = (standardsContext) => {
  if (!standardsContext) return null;
  const toOption = (value) => (value ? { id: value, name: value } : null);
  return {
    state: toOption(standardsContext.state),
    subject: toOption(standardsContext.subject),
    sourceName: toOption(standardsContext.sourceName),
  };
};

/**
 * Where a refresh-restored wizard resumes, from the session's server status
 * (ENG-23196). Returns null when there's nothing to resume — the caller
 * discards the draft.
 */
export const deriveStepFromStatus = (statusResponse, entryType) => {
  const status = statusResponse?.status;
  if (!status || !entryType || !ENTRY_STEPS[entryType]) return null;

  if (status === SESSION_STATUS.BUILT) return null;

  if (status === SESSION_STATUS.CREATED) {
    return { step: ENTRY_STEPS[entryType] };
  }

  if (status === SESSION_STATUS.FAILED) {
    const message =
      statusResponse.failureReason || "Something went wrong. Please try again.";
    const stage = statusResponse.failedStage;

    // Same routing as the modal's handleRecommendingFailed.
    if (stage === FAILED_STAGES.UPLOAD || stage === FAILED_STAGES.ANALYSIS) {
      return { step: STEPS.SYLLABUS_UPLOAD, syllabusUploadFailure: message };
    }
    return {
      step: STEPS.FORM,
      submitError: `${message} ${RECOMMENDING_RETRY_HINT}`,
    };
  }

  const step = STEPS_BY_STATUS[status];
  return step ? { step } : null;
};
